module.exports = __webpack_public_path__ + "static/media/addboardbr2x.c28d21fb.jpg";